import { useNavigate } from 'react-router-dom'
import { useState, FormEvent } from 'react'
import toast from 'react-hot-toast'
import { AuthData, HttpResponse } from '../components/commons'
import axiosInstance from '../components/lib/axiosInstance'
import logoFullImage from '../assets/images/logo/logofull.png'

type Props = {}

const Login: React.FC<Props> = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  // Function to handle login
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response = await axiosInstance.post<any, HttpResponse<AuthData>>(`/api/v1/Home/Authorize`, {
        username: email,
        password,
      })

      // Check the API response status
      if (response.data.status === false) {
        // If status is false, show the error message from the response
        const errorMessage = response.data.message || 'Login failed. Please try again.'
        toast.error(errorMessage)
      } 
      else {
        // If status is true, proceed with login
        toast.success(response.data.message || 'Login successful')
        // Store userId and token in local storage
        localStorage.setItem(
          'auth',
          JSON.stringify(response.data.data)
        )

        setTimeout(() => {
          navigate('/')
        }, 2000)
      }
    } catch (error) {
      // Handle network or server errors
      toast.error('An error occurred. Please try again.')
    } finally {
      setLoading(false) // End loading
    }
  }

  return (
    <section className="bg-gray-50 h-screen w-screen  flex items-center justify-center  dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center w-full px-6 py-2 mx-auto md:h-screen lg:py-0">
        <a
          href="#"
          className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
        >
          <img
            className="w-full h-10 mr-2"
            src={logoFullImage}
            alt="logo"
          />
        </a>
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Sign in to your account
            </h1>
            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              {' '}
              <div>
                <label
                  htmlFor="email"
                  className="block mb-1.5 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="name@company.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block mb-1.5 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="••••••••"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="flex items-center justify-between">
                <a
                  href="#"
                  className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Forgot password?
                </a>
              </div>
              <button
                type="submit"
                className="w-full text-white bg-primary-600 hover:bg-gray-800 focus:outline-none font-medium text-sm px-5 py-2.5 text-center bg-black"
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Sign in'}{' '}
              </button>
              <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                Don't have an account yet?{' '}
                <a
                  href="#"
                  className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Sign up
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Login
